module.exports = __webpack_public_path__ + "static/media/logo_secondario.9ed683b3.png";